"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DecorativeShape = void 0;
var react_1 = __importDefault(require("react"));
var imgix_1 = require("../../misc/Images/imgix");
var styles_1 = require("./styles");
var SHAPES = {
    'star-yellow': imgix_1.buildUrl('https://superhi.s3.amazonaws.com/assets/images/decorative-shapes/star-yellow.png', {}),
    'square-green': imgix_1.buildUrl('https://superhi.s3.amazonaws.com/assets/images/decorative-shapes/square-green.png', {}),
    'wedge-red': imgix_1.buildUrl('https://superhi.s3.amazonaws.com/assets/images/decorative-shapes/wedge-red.png', {}),
    'pentagon-blue': imgix_1.buildUrl('https://superhi.s3.amazonaws.com/assets/images/decorative-shapes/pentagon-blue.png', {}),
    'circle-pink': imgix_1.buildUrl('https://superhi.s3.amazonaws.com/assets/images/decorative-shapes/circle-pink.png', {}),
};
var DecorativeShape = function (_a) {
    var name = _a.name, size = _a.size, commonProps = __rest(_a, ["name", "size"]);
    return (react_1.default.createElement(styles_1.Wrapper, __assign({ "data-component-name": "DecorativeShape" }, commonProps, { src: SHAPES[name], "$size": size, alt: "" })));
};
exports.DecorativeShape = DecorativeShape;
exports.DecorativeShape.names = Object.keys(SHAPES);
exports.default = exports.DecorativeShape;
